
















import { Component, Prop, Vue } from 'vue-property-decorator'
// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import FilePond Plugins
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'

// Create component
const FilePond = vueFilePond(
	FilePondPluginImageExifOrientation,
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview,
	FilePondPluginImageResize,
	FilePondPluginImageTransform)

@Component({
	components: {
		FilePond,
	},
})
export default class FileUpload extends Vue {

	private handleFilePondInit() {
		const pond = this.getPond()._pond
		pond.setOptions({
			server: '',
			imagePreviewHeight: 200,
		})
		console.log(pond)
	}

	private getFiles() {
		const files = this.getPond().getFiles()
		console.log(files)
		files.forEach((file) => {
			console.log(file)
		})
	}

	private getPond() {
		const pond = this.$refs.pond as any
		return pond
	}
}
